/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Desk_New_VisitInputs */

const en_features_desk_new_visit = /** @type {(inputs: Features_Desk_New_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New visit`)
};

const pl_features_desk_new_visit = /** @type {(inputs: Features_Desk_New_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowa wizyta`)
};

/**
* | output |
* | --- |
* | "New visit" |
*
* @param {Features_Desk_New_VisitInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_new_visit = /** @type {((inputs?: Features_Desk_New_VisitInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_New_VisitInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_new_visit(inputs)
	return en_features_desk_new_visit(inputs)
});